import { render, staticRenderFns } from "./CreateAutoLeadVerticalStep2.vue?vue&type=template&id=b81c57d6&"
import script from "./CreateAutoLeadVerticalStep2.vue?vue&type=script&lang=ts&"
export * from "./CreateAutoLeadVerticalStep2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports